import * as L from 'leaflet'
import {
    Tls
} from '../tools/Tls';
import {
    DrawTls
} from '../tools/DrawTls';
import {
    PoleTls
} from '../tools/PoleTls';


const PoleDrawer = {

    // TODO can resize all poles
    // TODO group pole to remove
    draw: function (mymap, poleRow) {

        // var Detail = 2; // 0: nothing , 1: show branches ,  2: pole_num
        var Lockr = require("lockr");
        var Detail = 0+Lockr.get("branchLableType", 1);

        if (poleRow.fond_type.search('ا') > 0) {

            // if wood pole
            var fff = L.circle(Tls.str2center(poleRow.points), {
                draggable: true,
                radius: 1,
                color: '#000',
                fillColor: '#000',
                fillOpacity: 1
            }).addTo(mymap);
            fff.dragging.disable();

            // if (poleRow.harim > 0) {
            //     fff.bindTooltip(poleRow.harim.toString(), { opacity: .3 }).openTooltip();
            //     // fff.bindPopup('حریم').openPopup();
            // }
            fff.bindPopup(PoleTls.getInfo(poleRow));
            if(eval(poleRow.n_branch_light)+eval(poleRow.n_branch_1ph)+eval(poleRow.n_branch_3ph)>0 && Detail ==1)
            fff.bindTooltip(eval(poleRow.n_branch_light)+eval(poleRow.n_branch_1ph)+"+"+poleRow.n_branch_3ph, {
                permanent: true,opacity:.7,className: 'pole-label-tooltip'
            });

            // if(Detail ==2)
            // fff.bindTooltip(eval(poleRow.n_branch_light)+eval(poleRow.n_branch_1ph)+"+"+poleRow.n_branch_3ph, {
            //     permanent: true,opacity:.7,className: 'pole-label-tooltip'
            // });
            if(Detail ==2 && poleRow.pole_num!=0 && poleRow.pole_num!=undefined)
            fff.bindTooltip(poleRow.pole_num, {
                permanent: true,opacity:.7,className: 'pole-label-tooltip'
            })
            // var m = L.polygon(Tls.str2path(poleRow.points), { weight: 1, color: '#000', fillColor: "#fff", fillOpacity: 1 }).addTo(mymap);

        } else {

            let w = poleRow.weight;
            if (w == 0 || w == undefined) {
                w = 400;
            }

            let cn = Tls.str2centerInUTM(poleRow.points);
            let phase = poleRow.height;
            if (phase == 0 || phase == undefined)
                phase = 12;
            if (phase == 9) phase = 8;
            try {
                var group = L.featureGroup().addTo(mymap);

                var pjjj = DrawTls.drawRectangle(group, cn[0], cn[1], phase * .3, phase * .18, Tls.rectStr2angle(poleRow.points));
                let skin = this.drawPoleSkin(group, pjjj, w);

                skin.bindPopup(PoleTls.getInfo(poleRow));
                pjjj.myId = poleRow._id;
                pjjj.myType = 'pole';
                skin.myId = poleRow._id;
                skin.myType = 'pole';
                
                if(eval(poleRow.n_branch_light)+eval(poleRow.n_branch_1ph)+eval(poleRow.n_branch_3ph)>0 && Detail ==1)
                skin.bindTooltip(eval(poleRow.n_branch_light)+eval(poleRow.n_branch_1ph)+"+"+poleRow.n_branch_3ph, {
                    permanent: true,opacity:.7,className: 'pole-label-tooltip'
                })

                if(Detail ==2 && poleRow.pole_num!=0 && poleRow.pole_num!=undefined)
                skin.bindTooltip(poleRow.pole_num, {
                    permanent: true,opacity:.7,className: 'pole-label-tooltip'
                })

                // var group = L.featureGroup().addTo(mymap);
                // pjjj.addTo(group);
                // skin.addTo(group);

                // TODO light

                // var label = L.Tooltip({
                //     permanent:true
                // }).setContent('SSAFFA dsf').setLanLng(Tls.u(cn[0], cn[1]));
                // // mymap.showLable();
                // // label.addTo(mymap);
                // mymap.bindTooltip(label);

                return {
                    main: pjjj,
                    skin: skin
                };
            } catch (e) {
                console.log(e);
            }


            // var myIcon = L.divIcon({className: 'my-div-icon'});
            // L.marker(Tls.uNotSave(cn[0], cn[1]), {icon: myIcon}).addTo(mymap);

            //             var marker = new L.marker(Tls.uNotSave(cn[0], cn[1]), { opacity: 0.01 }); //opacity may be set to zero
            // marker.bindTooltip("My Label", {permanent: true, className: "my-label", offset: [0, 0] });
            // marker.addTo(mymap);




            return {};
            // TODO clear function

            // var icon = new L.TextIcon({ text: '12', color: 'red' });
            // L.marker(Tls.uNotSave(cn[0], cn[1] ), { icon: icon }).addTo(mymap);
            // var m = L.polygon(Tls.str2path(poleRow.POINTS), { weight: 1, color: '#000', fillColor: "#fff", fillOpacity: 1 }).addTo(mymap);
        }








        // drawRectangle(mymap,poleRow.center_X,poleRow.center_Y,5*.12,5*.18,poleRow.ANGLE);



        // draw line
        // label = '30m';
        // var str ='298985.01710000,3797146.81140000;298984.78080000,3797146.73900000;298960.50770000,3797139.30590000';

        // transform: true,
        // draggable: true,
        // https://github.com/w8r/Leaflet.Path.Drag
        // https://github.com/w8r/Leaflet.Path.Transform/

        // m.transform.enable({rotation: true, scaling: false,drag: true});
        // m.dragging.enable();
        // rotateend 
        // polygon.dragging.disable();


        // TODO if wood draw circle
        // TODO if 9 or 12 change size
        // L.marker(Tls.u(poleRow.center_X-poleRow.DX/2, poleRow.center_Y-poleRow.DY/2), {
        //     icon: getPoleIcon(poleRow)
        //     , rotationAngle: poleRow.ANGLE
        // }).addTo(mymap);

    },

    drawPoleSkin(mymap, pointsXY, w) {
        w = eval(w);
        // w = 800;
        // var pointsXY = Tls.str2xyArr(pointStr);
        var pSkin;
        switch (w) {
            case 200:
                pSkin = [
                    Tls.u1(pointsXY[4]),
                    Tls.u1(pointsXY[3]),
                    Tls.u1(Tls.midPointXY(pointsXY[2], pointsXY[3])),
                    Tls.u1(Tls.midPointXY(pointsXY[1], pointsXY[0])),
                    Tls.u1(pointsXY[0]),
                ];
                break;
            case 400:
                pSkin = [
                    Tls.u1(pointsXY[0]),
                    Tls.u1(pointsXY[1]),
                    Tls.u1(pointsXY[2]),
                    Tls.u1(pointsXY[3]),
                    Tls.u1(pointsXY[4]),
                ];
                break;

            case 600:
                pSkin = [
                    Tls.u1(pointsXY[0]),
                    Tls.u1(pointsXY[1]),
                    Tls.u1(Tls.midPointXY(pointsXY[1], pointsXY[2])),
                    Tls.u1(Tls.midPointXY(pointsXY[3], pointsXY[4])),
                    Tls.u1(pointsXY[0]),
                ];
                break;
            case 800:
                pSkin = [
                    Tls.u1(pointsXY[0]),
                    Tls.u1(pointsXY[1]),
                    Tls.u1(pointsXY[3]),
                    Tls.u1(pointsXY[0]),
                ];
                break;
            default: // like 400
                pSkin = [
                    Tls.u1(pointsXY[0]),
                    Tls.u1(pointsXY[1]),
                    Tls.u1(pointsXY[2]),
                    Tls.u1(pointsXY[3]),
                    Tls.u1(pointsXY[4]),
                ];
                break;
        }
        return L.polygon(pSkin, {
                weight: 0,
                color: '#000',
                fillColor: "#000",
                fillOpacity: 1
            })
            
            .addTo(mymap);

    },




}

export {
    PoleDrawer
}